import React, { useState, useRef } from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

const SingleImageViewer = ({ src, alt, onLoad }) => {
  const [imgDim, setImgDim] = useState({ w: 0, h: 0 });
  const [coverScale, setCoverScale] = useState(1);

  const containerRef = useRef(null);

  // When the image loads, grab its natural size & compute coverScale
  const handleImageLoad = (e) => {
    const { naturalWidth: w, naturalHeight: h } = e.target;
    setImgDim({ w, h });

    const { width: cw, height: ch } = containerRef.current.getBoundingClientRect();

    // scale so that the image COVERS the container
    const scale = Math.max(cw / w, ch / h);
    setCoverScale(scale);
    if (onLoad) onLoad();
  };

  // Don’t render the wrapper until we know the dims
  if (imgDim.w === 0) {
    return (
      <div ref={containerRef} style={{ width: "100%", height: "100%" }}>
        <img
          src={src}
          alt={alt}
          onLoad={handleImageLoad}
          style={{ display: "none" }}
        />
      </div>
    );
  }

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <TransformWrapper
        initialScale={coverScale}
        minScale={coverScale * 0.25}
        maxScale={coverScale * 3}
        centerOnInit={true}
      >
        <TransformComponent
          wrapperStyle={{
            width: "100%",
            height: "100%",
            overflow: "hidden",
          }}
          contentStyle={{
            // full–size content = natural image dimensions
            width: imgDim.w,
            height: imgDim.h,
          }}
        >
          <img
            src={src}
            alt={alt}
            draggable={false}
            style={{
              width: imgDim.w,
              height: imgDim.h,
              objectFit: "contain",
              userSelect: "none",
              pointerEvents: "none",
            }}
          />
        </TransformComponent>
      </TransformWrapper>
    </div>
  );
};

export default SingleImageViewer;